(function () {
  'use strict';

  function scrollStep(track) {
    var grid = track.querySelector('.hr-popular__grid, .hr-brands__row');
    if (!grid) return Math.round(track.clientWidth * 0.75);

    var card =
      grid.querySelector('.hr-card--standard') ||
      grid.querySelector('.hr-card, .hr-brand');
    if (!card) return Math.round(track.clientWidth * 0.75);

    var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 14;
    return Math.round(card.offsetWidth + gap);
  }

  function updatePopularLayout(section, track) {
    var grid = track.querySelector('.hr-popular__grid');
    if (!grid) return;

    section.classList.add('hr-popular--scroll');
    section.classList.remove('hr-popular--fit');

    var overflows = grid.scrollWidth > track.clientWidth + 2;
    if (!overflows) {
      section.classList.remove('hr-popular--scroll');
      section.classList.add('hr-popular--fit');
      track.scrollLeft = 0;
    }
  }

  function bindCarousel(section, trackSel, prevSel, nextSel) {
    var track = section.querySelector(trackSel);
    var prev = section.querySelector(prevSel);
    var next = section.querySelector(nextSel);
    if (!track || !prev || !next) return;

    var isPopular = section.classList.contains('hr-popular');

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function syncArrows() {
      var max = maxScroll();
      var left = track.scrollLeft;
      prev.disabled = left <= 1;
      next.disabled = left >= max - 1;
      prev.setAttribute('aria-disabled', prev.disabled ? 'true' : 'false');
      next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
    }

    function sync() {
      if (isPopular) updatePopularLayout(section, track);
      syncArrows();
    }

    function scrollByDir(dir) {
      var step = scrollStep(track);
      var target = track.scrollLeft + dir * step;
      var max = maxScroll();
      track.scrollTo({ left: Math.min(max, Math.max(0, target)), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () {
      scrollByDir(-1);
    });
    next.addEventListener('click', function () {
      scrollByDir(1);
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(sync);
      ro.observe(track);
      var inner = track.firstElementChild;
      if (inner) ro.observe(inner);
    }
    sync();
    requestAnimationFrame(function () {
      sync();
      requestAnimationFrame(syncArrows);
    });
  }

  function initYoutubeModal(section) {
    if (!section.classList.contains('hr-youtube') || section.dataset.hrYtBound === 'true') return;
    section.dataset.hrYtBound = 'true';

    var modal = section.querySelector('[data-hr-yt-modal]');
    if (!modal) return;

    var iframe = modal.querySelector('iframe');
    var lastFocus = null;

    function closeModal() {
      if (modal.hidden) return;
      if (iframe) iframe.src = '';
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hr-yt-modal-open');
      if (lastFocus) lastFocus.focus();
      lastFocus = null;
    }

    function openModal(trigger) {
      var id = trigger.getAttribute('data-youtube-id');
      if (!id || !iframe) return;

      lastFocus = trigger;
      iframe.src =
        'https://www.youtube.com/embed/' +
        encodeURIComponent(id) +
        '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hr-yt-modal-open');
    }

    section.querySelectorAll('[data-hr-yt-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(trigger);
      });
    });

    modal.querySelectorAll('[data-hr-yt-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    section._hrYtEscHandler = function (e) {
      if (e.key === 'Escape') closeModal();
    };
    document.addEventListener('keydown', section._hrYtEscHandler);
  }

  function initSection(section) {
    if (section.classList.contains('hr-popular')) {
      bindCarousel(section, '[data-hr-track]', '[data-hr-prev]', '[data-hr-next]');
    }
    if (section.classList.contains('hr-brands')) {
      bindCarousel(section, '[data-hr-track]', '[data-hr-prev]', '[data-hr-next]');
    }
    if (section.classList.contains('hr-youtube')) {
      initYoutubeModal(section);
    }
  }

  function boot() {
    document.querySelectorAll('[data-home-redesign]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('[data-home-redesign]')) initSection(el);
    else if (el) {
      var inner = el.querySelector('[data-home-redesign]');
      if (inner) initSection(inner);
    }
  });
})();
